/**
 * Header control that simulates a dead network for offline testing.
 */
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

import { VButton } from "form";
import { isOnline, setForceOffline, subscribeNetwork } from "./network";

/**
 * Toggles simulated offline mode. The choice survives refresh in this tab.
 *
 * @returns {JSX.Element}
 */
const OfflineToggle = () => {
  const [online, setOnline] = useState(isOnline());

  useEffect(() => subscribeNetwork(setOnline), []);

  /**
   * Flips simulated offline mode.
   *
   * @returns {void}
   */
  const onToggle = () => setForceOffline(online);

  return (
    <VButton
      variant="outlined"
      color={online ? "secondary" : "warning"}
      className="mr-4 px-3 py-1 min-w-0 whitespace-nowrap"
      onClick={onToggle}
      title={online ? "Simulate offline" : "Go back online"}
    >
      <Icon icon={online ? "mdi:wifi" : "mdi:wifi-off"} className="text-lg flex-shrink-0" />
      <span className="ml-1 text-xs font-bold">{online ? "Online" : "Offline"}</span>
    </VButton>
  );
};

export default OfflineToggle;
